import React, { FC, PropsWithChildren } from 'react';

import AppLoadingState from 'components/AppLoadingState';

import { useInitialiseGlobalStateAwaitable } from './useInitialiseGlobalStateAwaitable';
import { GlobalStateProvider } from './GlobalState';
import { useTriggerGlobalSagas } from './useTriggerGlobalSagas';

export const LoggedInGlobalState: FC<PropsWithChildren> = ({ children }) => {
  const { awaitable: sagasAwaitable } = useTriggerGlobalSagas();
  const stateAwaitable = useInitialiseGlobalStateAwaitable();
  if (sagasAwaitable.loading === true || stateAwaitable.loading === true) {
    return <AppLoadingState />;
  }
  return (
    <GlobalStateProvider initialState={stateAwaitable.data}>
      {children}
    </GlobalStateProvider>
  );
};
